import Vue from 'vue';

import { apiPath } from '@/api/constants';

export default Vue.resource(
  `${apiPath}/discoveryads/campaigns{/campaignId}{/get}{/action}/`,
  {},
  {
    updateCampaign: { method: 'PATCH' },
    getOverall: { method: 'GET', params: { get: 'overall' } },
    saveCSV: { method: 'GET', params: { get: 'export' } },
    saveOverallCSV: {
      method: 'GET',
      params: { get: 'overall', action: 'export' },
    },
  },
  {
    transformToCamelCase: true,
  },
);
